import { motion } from "framer-motion";
import React, { useContext, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import VisibilitySensor from "react-visibility-sensor";
import audioImg from "../../assets/images/exp_audio.jpg";
import c64Img from "../../assets/images/exp_c64.jpg";
// import codePlayground from "../../assets/images/exp_code.jpg";
import coffeeImg from "../../assets/images/exp_coffee.jpg";
import osImg from "../../assets/images/exp_os.jpg";
import terminalImg from "../../assets/images/exp_terminal.jpg";
import thirdControllerImg from "../../assets/images/exp_thirdcontroller.jpg";
import chatbotImg from "../../assets/images/exp_chatbot.jpg";
import softwareAiImg from "../../assets/images/exp_software_ai.jpg";
import starImg from "../../assets/images/exp_star.jpg";
import satellitesImg from "../../assets/images/exp_satellites.jpg";
import cloudPlayerImg from "../../assets/images/exp_cloudplayer.jpg";
import officeImg from "../../assets/images/exp_office.jpg";
import waterImg from "../../assets/images/exp_water.jpg";
import videoImg from "../../assets/images/exp_video.jpg";
import webEditor from "../../assets/images/exp_webeditor.jpg";
import { Context } from "../../context";
import classes from "./Experiments.module.css";
import ExperimentsCard from "./ExperimentsCard";

const Experiments = () => {
  const [overlay, setOverlay] = useState(false);
  const demoSectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang, terminal, setTerminal, setViewMode } =
    useContext(Context);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const experiments = [
    {
      id: 11,
      titleIt: "Chatbot AI",
      titleEn: "AI Chatbot",
      descIt: "Un chatbot intelligente basato su intelligenza artificiale per rispondere alle domande degli utenti in tempo reale.",
      descEn: "An intelligent AI-powered chatbot designed to answer user queries in real-time.",
      file: "chatbot_ai.js",
      img: chatbotImg,
      url: "https://chatbot-ai.davidebalice.dev/",
    },
    {
      id: 15,
      titleIt: "Software AI con Riconoscimento Vocale",
      titleEn: "Software AI with Voice Recognition",
      descIt: "Applicazione e-commerce avanzata integrata con riconoscimento vocale e intelligenza artificiale per un'esperienza utente interattiva.",
      descEn: "Advanced e-commerce application integrated with speech recognition and artificial intelligence for an interactive user experience.",
      file: "software_ai.js",
      img: softwareAiImg,
      url: "https://chatbot-ai.davidebalice.dev/ecommerce-ai/index.html",
    },
    {
      id: 10,
      titleIt: "Third Person Controller",
      titleEn: "Third Person Controller",
      descIt: "Un controller di gioco in terza persona in ambiente 3D realizzato con Three.js e librerie fisiche per movimenti fluidi.",
      descEn: "A 3D third-person game controller built with Three.js and physics libraries for smooth movements.",
      file: "third_person_controller.js",
      img: thirdControllerImg,
      url: "https://third-person-controller.davidebalice.dev/",
    },
    {
      id: 12,
      titleIt: "Star Explorer",
      titleEn: "Star Explorer",
      descIt: "Un'esplorazione spaziale interattiva in 3D con simulazione orbitale di pianeti e stelle.",
      descEn: "An interactive 3D space exploration tool featuring orbital simulation of planets and stars.",
      file: "star_explorer.js",
      img: starImg,
      url: "https://star-explorer.davidebalice.dev/",
    },
    {
      id: 13,
      titleIt: "Tracciamento Satelliti",
      titleEn: "Satellites Tracking",
      descIt: "Tracciamento in tempo reale dei satelliti in orbita terrestre tramite visualizzazione 3D dinamica.",
      descEn: "Real-time tracking of satellites in Earth orbit using a dynamic 3D visualization.",
      file: "satellites_tracking.js",
      img: satellitesImg,
      url: "https://satellites-tracking.davidebalice.dev/",
    },
    {
      id: 17,
      titleIt: "Office",
      titleEn: "Office",
      descIt: "Work Room 3D interattiva sviluppata in Three.js.",
      descEn: "Interactive 3D Work Room developed in Three.js.",
      file: "office_workroom.js",
      img: officeImg,
      url: "https://workroom.davidebalice.dev/",
    },
    {
      id: 16,
      titleIt: "Cloud Player",
      titleEn: "Cloud Player",
      descIt: "Lettore multimediale che legge i file dal proprio Drive, utilizzando le API ufficiali Google.",
      descEn: "Media player that reads files from one's own Drive, using official Google APIs.",
      file: "cloud_player.js",
      img: cloudPlayerImg,
      url: "/experiments/cloud-player",
    },
    {
      id: 14,
      titleIt: "Simulazione Acqua",
      titleEn: "Water Simulation",
      descIt: "Simulazione fisica realistica dell'acqua e dei fluidi in tempo reale con rendering 3D.",
      descEn: "Realistic fluid and water physics simulation in real-time with stunning 3D rendering.",
      file: "water_simulation.js",
      img: waterImg,
      url: "https://water-simulation.davidebalice.dev/",
    },
    {
      id: 1,
      titleIt: "Terminal",
      titleEn: "Terminal",
      descIt: "Un emulatore di terminale interattivo connesso a un'API Node.js per navigare nel file system remoto.",
      descEn: "An interactive terminal emulator connected to a Node.js API to navigate the remote file system.",
      file: "terminal.js",
      img: terminalImg,
      github: "https://github.com/davidebalice/react-terminal-emulator",
      github2: "https://github.com/davidebalice/node-file-system-api",
    },
    {
      id: 2,
      titleIt: "Interfaccia OS",
      titleEn: "OS Interface",
      descIt: "Riproduzione di un'interfaccia a finestre in stile sistema operativo desktop con gestione drag & drop.",
      descEn: "Recreation of a desktop OS-style windowed interface with drag-and-drop management.",
      file: "os_interface.js",
      img: osImg,
      github: "https://github.com/davidebalice/react-os-interface",
      github2: "https://github.com/davidebalice/node-file-system-api",
    },
    {
      id: 3,
      titleIt: "Web Editor",
      titleEn: "Web Editor",
      descIt: "Prototipo di editor visuale drag and drop per costruire e personalizzare pagine web in modo semplice.",
      descEn: "Prototype of a drag-and-drop visual editor to build and customize web pages easily.",
      file: "web_editor.js",
      img: webEditor,
      github: "https://github.com/davidebalice/react-website-editor-prototype",
    },

    {
      id: 4,
      titleIt: "Coffee Break",
      titleEn: "Coffee Break",
      descIt: "Un simpatico mini-gioco o esperimento interattivo a tema caffè per una pausa rilassante.",
      descEn: "A cute coffee-themed mini-game or interactive experiment for a relaxing break.",
      file: "coffee_break.js",
      img: coffeeImg,
      github: "",
    },
    {
      id: 5,
      titleIt: "Lettore Audio",
      titleEn: "Audio Player",
      descIt: "Lettore musicale moderno con playlist, visualizzatore audio e controlli riproduzione avanzati.",
      descEn: "Modern music player with playlists, audio visualizer, and advanced playback controls.",
      file: "audio_player.js",
      img: audioImg,
      github: "https://github.com/davidebalice/audio-player",
    },
    {
      id: 6,
      titleIt: "Lettore Video",
      titleEn: "Video Player",
      descIt: "Riproduttore video fluido con controlli personalizzati, supporto per streaming e playlist.",
      descEn: "Smooth video player featuring custom controls, streaming support, and playlists.",
      file: "video_player.js",
      img: videoImg,
      github: "https://github.com/davidebalice/video-player",
    },
    {
      id: 7,
      titleIt: "C64",
      titleEn: "C64",
      descIt: "Un omaggio nostalgico al leggendario Commodore 64 con emulazione dell'interfaccia classica e tastiera.",
      descEn: "A nostalgic tribute to the legendary Commodore 64 with classic interface emulation and keyboard support.",
      file: "c64.js",
      img: c64Img,
      github: "",
    },
  ];

  return (
    <>
      {overlay && <div className={classes.overlay}></div>}
      <section id="demoHome" className={`${classes.demoHome} section p_zero`}>
        <div className="text-center py-5">
          <div className="container">
            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{
                  opacity: isVisible ? 1 : 0,
                }}
                transition={{ duration: 0.4, delay: 0.65 }}
                className={`text-4 text-dark w-100 align-self-center text-start lh-base mb-0 mt-1 m-auto ${classes.demoText}`}
              >
                {lang === "en" && (
                  <>
                    In this section of the website, there are{" "}
                    <b>some experiments</b>: examples of interfaces, media
                    player and games.
                    <br />
                    <b>Terminal</b> is a real terminal, allowing navigation
                    through the server's file system via text commands.
                    <br />
                    <b>Os</b> is an app that recreates the design of an{" "}
                    <b>operating system</b> similar to Windows, with a system of{" "}
                    <b>multiple windows</b> that can be moved, resized, or
                    minimized, ideal for having multiple pieces of information
                    open simultaneously.
                    <br />
                    There is also a <b>Third Person Controller</b>, a <b>Chatbot AI</b>, an <b>audio player</b>, <b>video player</b>{" "}
                    and a <b>gaming hub</b>.
                  </>
                )}
                {lang === "it" && (
                  <>
                    In questa sezione del sito web sono presenti{" "}
                    <b>alcuni esperimenti:</b> esempi di interfacce, media
                    player e giochi.
                    <br />
                    <b>Terminal</b> è un vero <b>terminale</b>, che consente di
                    navigare tra il <b>file system</b> del server tramite
                    comandi testuali.
                    <br />
                    <b>Os</b> è un app che ripropone il design di un{" "}
                    <b>sistema operativo</b> simile a Windows, con un sistema di{" "}
                    <b>finestre multiple</b> che possono essere spostate,
                    ridimensionate o ridotte a icona, ideale per avere più
                    informazioni aperte contemporaneamente.
                    <br />
                    E' presente inoltre un <b>Third Person Controller</b>, un <b>Chatbot AI</b>, un <b>audio player</b>,{" "}
                    <b>video player</b> ed un <b>gaming hub</b>.
                  </>
                )}

                <br />
              </motion.p>
            </VisibilitySensor>
          </div>
        </div>
        <Container
          ref={demoSectionRef}
          fluid
          className={`${classes.demoCardContainer} text-center`}
        >
          <div className={`${classes.topLinea}`}></div>

          <div className="row gx-4 mx-lg-4 demo">
            {experiments.map((item) => (
              <>
                <ExperimentsCard
                  key="ddd"
                  card={item}
                  delay={2}
                  terminal={terminal}
                  setTerminal={setTerminal}
                  setViewMode={setViewMode}
                />
              </>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Experiments;
